<template>


    <div class="app-car-checkbox-buttons" :class="{'has-message': message && message.length}">
        <div class="checkbox-buttons-wrap">
<!--            <button @click="buttonYes">Yes</button>-->
<!--            <button @click="buttonNo">No</button>-->
            <span class="label"><slot></slot></span>

            <label>
                <span class="control">
                    <input type="checkbox"
                           v-model="newValue"
                           :class="{'has-value': newValue !== null}"
                           :placeholder="placeholderTrans"
                           @change="e => onInput(e)">

                    <span class="switch">
                        <span class="switch-text switch-checked">{{ checkedText }}</span>
                        <span class="switch-text switch-not-checked">{{ uncheckedText }}</span>
                    </span>
                </span>
            </label>
        </div>

        <p class="message" v-if="message">{{ message }}</p>
    </div>

</template>

<script>

    export default {

        props: {
            value: [Boolean],
            placeholder: String,
            checkedText: String,
            uncheckedText: String,
            error: Boolean,
            message: String,
        },

        data() {
            return {
                newValue: this.value
            }
        },

        watch: {
            value() {

                this.newValue = this.value;
            }
        },

        methods: {
            buttonYes() {
                console.log('yes')
            },
            buttonNo() {
                console.log('no')
            },

            onInput(e) {
                console.log(e.target)
                    this.$emit('input', this.newValue);
                    this.$emit('change', this.newValue);
            }

        },

        computed: {
            placeholderTrans() {
                return this.placeholder ? $trans(this.placeholder) : '';
            }
        }

    }

</script>

<style lang="scss" scoped>

    .app-car-checkbox-buttons {
        position: relative;

        .checkbox-buttons-wrap {
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            justify-content: space-between;

            label {
                display: flex;
                align-items: center;
            }

            .control {
                position: relative;
                cursor: pointer;
                margin-right: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;

                span {
                    display: block;
                }

                span.switch {
                    background-color: $white;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    position: relative;

                    .switch-text {
                        font-size: 20px;
                        font-weight: $font-light;
                        line-height: 33px;
                        color: $black;
                        text-align: center;
                        z-index: 1;
                        transition: all .2s ease-in-out;
                        width: 100px;
                        height: 44px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: solid 1px $medium-gray;
                    }
                }

                input {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    opacity: 0;
                    z-index: 2;
                    cursor: pointer;

                    &:checked.has-value {
                        + .switch {
                            .switch-checked {
                                border: solid 1px $primary-blue;
                                color: $primary-blue;
                            }
                        }
                    }

                    &:not(:checked).has-value {
                        + .switch {
                            .switch-not-checked {
                                border: solid 1px $primary-blue;
                                color: $primary-blue;
                            }
                        }
                    }
                }

            }
        }

        .label {
            font-size: 20px;
            font-weight: $font-light;
            letter-spacing: 0.8px;
            color: $black;
        }

        .message {
            font-size: 1em;
            margin: 10px 0 0;
            color: $error-red;
            font-weight: $font-normal;
        }

    }

</style>
